import React, { useEffect } from "react";
import { Nav } from "./Nav";
import { Footer } from "./Footer";
import "../../marketing.css";

/**
 * MarketingLayout wraps every marketing route. The `.mkt` class scopes
 * every marketing-only CSS variable and selector so nothing here can bleed
 * into the audit respondent flow or admin surfaces.
 */
export function MarketingLayout({ children, active, title, description }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) {
        m = document.createElement("meta");
        m.setAttribute("name", "description");
        document.head.appendChild(m);
      }
      m.setAttribute("content", description);
    }
  }, [title, description]);

  return (
    <div className="mkt" data-testid="mkt-layout">
      <Nav active={active} />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
